export default __webpack_public_path__ + "static/media/disappointingEmoji.49a0fb42.svg";